import { deriveSessionStatus } from '../domain/training.ts';
import type { RoutineRevision, SessionStatus, TrainingResult } from '../domain/training.ts';
import type { TrainingRepository, SessionHistoryView } from '../ports/training-repository.ts';
export interface TrainingHistoryEntry extends SessionHistoryView { routine: RoutineRevision; status: SessionStatus }
export class TrainingHistory {
  constructor(private readonly repository: Pick<TrainingRepository, 'listSessionHistory'>,
    private readonly catalog: Pick<TrainingRepository, 'readRoutineRevision'>) {}
  async listHistory(): Promise<TrainingResult<readonly TrainingHistoryEntry[]>> {
    const snapshot = await this.repository.listSessionHistory(); if (!snapshot.ok) return snapshot;
    const entries: TrainingHistoryEntry[] = [];
    for (const entry of snapshot.value) {
      const status = deriveSessionStatus(entry.session, entry.execution); if (!status.ok) return status;
      const routine = await this.catalog.readRoutineRevision(entry.session.routineRevisionRef); if (!routine.ok) return routine;
      entries.push({ ...entry, routine: routine.value, status: status.value });
    }
    // Civil planned date descending; identity breaks ties deterministically. No date-based outcome inference.
    entries.sort((a,b) => b.session.plannedLocalDate.localeCompare(a.session.plannedLocalDate) || a.session.sessionId.localeCompare(b.session.sessionId));
    return { ok: true, value: entries };
  }
}
